import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const contactTypesAdapter = getAdapter({ idFieldName: 'id' });

const contactTypesSlice = createSlice({
  name: 'contactTypes',
  initialState: contactTypesAdapter.getInitialState(),
  reducers: {
    setContactTypes: (state, { payload: { contactTypes } }) => {
      contactTypesAdapter.setAll(state, contactTypes);
    }
  }
});

const selectors = contactTypesAdapter.getSelectors(({ contactTypes }) => contactTypes);

export const getContactTypes = state => selectors.selectAll(state);

export const { setContactTypes } = contactTypesSlice.actions;

export default contactTypesSlice.reducer;
